import {HorizontalRuleNode} from '@lexical/react/LexicalHorizontalRuleNode';
import {HeadingNode, QuoteNode} from '@lexical/rich-text';
import {AutoLinkNode, LinkNode} from '@lexical/link';
import {ListItemNode, ListNode} from '@lexical/list';
import {ImageNode} from './nodes/ImageNode/ImageNode';
import {StyledTextNode} from './nodes/StyledText';
import {EmojiNode} from './nodes/EmojiNode';
import theme from './themes';
import {TableCellNode, TableNode, TableRowNode} from '@lexical/table';

export function getEditorConfig(namespace: string) {
    return {
        namespace,
        theme,
        // Handling of errors during update
        onError(error: any) {
            throw error;
        },
        // Any custom nodes go here
        nodes: [
            EmojiNode,
            StyledTextNode,
            ImageNode,
            HeadingNode,
            ListNode,
            ListItemNode,
            QuoteNode,
            HorizontalRuleNode,
            AutoLinkNode,
            LinkNode,
            TableCellNode,
            TableNode,
            TableRowNode
        ]
    };
}
